export default {
	"uzbekistan_national_media_association" : "Национальная Медия Ассоциация Узбекистана",
	'media_platform': "Медия платформа",
	"username": "Имя пользователся",
	"password": "Пароль",
	"approve": "Утвердить",
	"sign_in": "Вход",
	"error": "Xato",
	"success": "Успешно",
	'login': 'Залогиниться',
	'create': 'Создать',
	'cancel': 'Отменить',
	'delete': 'Удалить',
	'really_wanna_delete': 'Действительно хотите удалить?',
	'search': 'Поиск',
	'actions': 'Действия',
	'update': 'Обновить',
	'place': 'Место',
	'phone': 'Номер телефона',
	'logo': 'Логотип',
	'total_count': 'Общее',
	'file': 'Файл',
	'director': 'Директор',
	'chancery': 'Концелярия',
	'select_file': 'Выберите файл',
	'delete_file': 'Удалить файл',
	'select_logo': 'Выберите логотип',
	'delete_logo': 'Удалить логотип',
	'select_image': 'Выберите картинку',
	'delete_image': 'Удалить картинку',
	'select': 'Выберите',
	'save': 'Сохранить',
	'close': 'Закрыть',
	'download_file': 'Скачать файл',
	'forbidden': 'Запрещено',
	'not_found': 'Не найдено',
	'return_back': 'Вернуться назад',


	'ru': 'Русский',
	'uz': 'Узбекский',

	'name': 'Название',
	'organization': 'Организация',
	'date': 'Дата',
	'the_date_of_the': 'Дата мероприятия',
	'address': 'Адрес',
	'description': 'Описание',
	'in_priority': 'В приоритете',



	'January': 'Январь',
	'February': 'Февраль',
	'March': 'Март',
	'April': 'Апрель',
	'May': 'Май',
	'June': 'Июнь',
	'July': 'Июль',
	'August': 'Август',
	'September': 'Сентябрь',
	'October': 'Октябрь',
	'November': 'Ноябрь',
	'December': 'Декабрь',


	'Monday': 'Пн',
	'Tuesday': 'Вт',
	'Wednesday': 'Ср',
	'Thursday': 'Чт',
	'Friday': 'Пт',
	'Saturday': 'Сб',
	'Sunday': 'Вс',


	'main_information': 'Общая информация',


	'events': 'Мероприятия',
	'event': 'Мероприятие',
	'create_new_event': 'Создать новое мероприятие',
	'no_events': 'Мероприятий нет',
	'open_event': 'Открыть мероприятие',
	'from_date': 'С даты',
	'to_date': 'По дата',
	'add_link': 'Добавить ссылку',
	'link': 'Ссылка',
	'participate_channels': 'Участвующие каналы',
	'subscribed_users': 'Подписанные пользователи',
	'export_excel': 'Экспортировать в экзель',
	'participate': 'Участвовать',
	'unparticipate': 'Не участвовать',
	'subscribe': 'Подписаться',
	'unsubscribe': 'Отписаться',
	'update_event': 'Обновить мероприятие',
	'really_wanna_participate': 'Действительно хотите участвовать?',
	'really_wanna_unparticipate': 'Действительно хотите отменить участие?',
	'really_wanna_subscribe': 'Действительно хотите подписаться?',
	'really_wanna_unsubscribe': 'Действительно хотите отписаться?',

	'channels': 'Каналы',
	'channel': 'Канал',
	'no_channels': 'Нет каналов',
	'create_new_channel': 'Создать новый канал',
	'score': 'Балл',

	'users': 'Пользователи',
	'user': 'Пользователь',
	'full_name': 'ФИО',
	'email': 'Эл.адрес',
	'create_new_user': 'Создать нового пользователя',
	'no_users': 'Нет пользователей',
	'image': 'Картинка',
	'update_user': 'Обновить пользователя',

	'roles': 'Роли',
	'role': 'Роли',
	'no_roles': 'Нет ролей',

	'permissions': 'Разрешения',
	'permission': 'Разрешение',
	'no_permissions': 'Нет разрешений',
}